import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import { logEngagement } from "../helper/log.helper";

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export default function GameResult({
  faildMessage,
  successMessage,
  isSuccess,
  moreUrl,
  challengeId,
  className,
}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const npi = searchParams.get("npi");
  const hem = searchParams.get("hem");
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign") || searchParams.get("utm_campaign ");

  const ipAddress = useSelector((state) => state.ipAddress);

  const formattedFailedMessage =
    faildMessage && faildMessage !== ""
      ? faildMessage
          .replace(/<[^>]+>/g, "")         
          .replace(/( COPD)/, "<br/>$1") 
      : "Unfortunately, you did not pass it in time.";

  const formattedSuccssMessage = 
    successMessage && successMessage !== ""
      ? successMessage
        .replace(/<[^>]+>/g, "")   
      : "Great job! You passed the game in time.";

  const handleNavigation = (url) => {
    if (url) {
      let payload = {
        npi: npi,
        hem: hem,
        ipAddress: ipAddress,
        engagementRefId: "Message Page",
        engagementSecRefId: challengeId,
        engagementType: "Clicked CTA",
        distinationUrl: url,
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmCampaign,
        timeToComplete: "",
        gameResult: "",
      };
      logEngagement(payload);

      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "http://" + url; // Default to http if no protocol is specified
      }

      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box
      sx={{
        px: { md: 2, sm: 2, xs: 2 },
        py: { md: 4, sm: 3, xs: 2 },
        border: "2px solid #ccc",
        borderRadius: 10,
        bgcolor: "#fff",
        mt: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: {md: 3, sm: 2, xs: 1},
        }}
        className={className}
      >
        <Box
          sx={{
            textAlign: "center",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              fontSize: {md: "42px", sm: "34px", xs: "7vw"},
              fontWeight: 700,
              color: isSuccess ? "rgb(113, 201, 240)" : "#FF0000",
            }}
          >
            {isSuccess ? "CONGRATULATIONS!" : "TIME'S UP!"}
          </Typography>
        </Box>
        {isSuccess ? (
          <Typography
            sx={{
              fontSize: {md: "17pt", sm: "20px", xs: "16px"},
              fontWeight: 500,
              color: "#000",
              textAlign: "center",
            }}
            dangerouslySetInnerHTML={{ __html: formattedSuccssMessage }}
          ></Typography>
        ) : (
          
          <Typography
            sx={{
              fontSize: {md: "16.5pt", sm: "20px", xs: "16px"},
              fontWeight: 'bold',
              color: "#000",
              textAlign: "center",
            }}        
              dangerouslySetInnerHTML={{ __html: formattedFailedMessage }}
          >
          </Typography>
        )}

        <Button
          variant="contained"
          size="medium"
          color="success"
          sx={{
            backgroundColor: "#A2D049",
            fontSize: {sm: "20px", xs: "16px"},
            fontWeight: 600,
            marginTop: "15px",
            color: "#021637",
            width: {sm: "250px", xs: "150px"},
            py: 1,
            "&:hover": {
              bgcolor: "#bcf154",
            },
          }}
          onClick={() => handleNavigation(moreUrl)}
        >
          Learn More
        </Button>
      </Box>
    </Box>
  );
}
